import { SearchCriteria } from "./search-criteria";

export class GetClientSalesSearchCriteria extends SearchCriteria {

}
